/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const peaq_chain_about = () => `peaq is the decentralized Web3 network powering the Economy of Things. Built with Substrate and designed to solve some of our biggest societal and economic challenges, it ensures that the incentives of people and increasingly intelligent machines are aligned.`
